import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function accounts() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`account/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`account/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('account/create', data);
    }

    function update(data) {
        return axiosInstance.patch('account/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`account/delete`, {
            data: {
                id: id
            }
        });
    }
}
